export default __webpack_public_path__ + "static/media/banco-santander.03ec148d.svg";